module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "ch02"
    }
  }, [_c('h1', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuridl0007#rch02"
    }
  }, [_vm._v("It Was Last Night, I Think")])]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "sl"
  }, [_vm._v("During the storm,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("I wondered")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("about gathering")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("all the drops.")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("From there it")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("took off into all")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("this other stuff: light")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("on the underside")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("of leaves, what")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("rust peels away,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("the space between")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("musical notes. I forgot")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("what time it was; I")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("wrote that down.")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("When I was a kid")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("I loved plus signs")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("and hummingbirds")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("in the honeysuckle.")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("I have jars filled")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("with words my")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("father left behind.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec8b7712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-ridl-0010.vue
// module id = 81
// module chunks = 0